import { withSvgIcon } from './withSvgIcon';

export const OctagonWarning = withSvgIcon(
  <>
    <path
      d="M7.49392 3.77815C7.99217 3.27991 8.66793 3 9.37255 3L14.6274 3C15.3321 3 16.0078 3.27991 16.5061 3.77815L20.2218 7.49392C20.7201 7.99217 21 8.66793 21 9.37255V14.6274C21 15.3321 20.7201 16.0078 20.2218 16.5061L16.5061 20.2218C16.0078 20.7201 15.3321 21 14.6274 21H9.37255C8.66793 21 7.99217 20.7201 7.49392 20.2218L3.77815 16.5061C3.27991 16.0078 3 15.3321 3 14.6274L3 9.37255C3 8.66793 3.27991 7.99217 3.77815 7.49392L7.49392 3.77815Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <circle cx="11.9998" cy="15.6355" r="1.19995" fill="currentColor" />
    <path
      d="M10.8474 7.48946C10.8328 7.31456 10.9708 7.16455 11.1464 7.16455H12.8742C13.0497 7.16455 13.1878 7.31456 13.1732 7.48946L12.7232 12.8895C12.7102 13.045 12.5803 13.1646 12.4242 13.1646H11.5964C11.4403 13.1646 11.3103 13.045 11.2974 12.8895L10.8474 7.48946Z"
      fill="currentColor"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
